import React from 'react'
import { usePersonalizedModuleConfig } from '../../personalization/usePersonalizedModuleConfig'
import { useHighlightedText } from '../../hooks/useHighlightedText'
import { useMaskedFirstName } from '../../hooks/useMaskedFirstName'
import { MODULE_KEYS, HEADING_DEFAULTS } from '../../moduleRegistry'
import { Heading } from './Heading'
import { Subheading } from './Subheading'
import '../../styles/HeadingModule/HeadingModule.scss'

export const HeadingModule = () => {
  const { heading, subheading } = usePersonalizedModuleConfig(MODULE_KEYS.heading, HEADING_DEFAULTS)
  const { firstName, maskFirstName } = useMaskedFirstName()

  // `heading` is flag-authored JSON and useModuleConfig does not merge in HEADING_DEFAULTS, so
  // it can arrive missing or non-string. Resolve it to the default before use: there is no
  // ErrorBoundary under matchScreen, so a non-string must never reach useHighlightedText.
  const configuredHeading = typeof heading === 'string' ? heading : HEADING_DEFAULTS.heading

  // No known first name -> default heading, even for configured copy that never references the
  // name. The fallback is deliberately unconditional: narrowing it to headings containing
  // [first_name] would change rendered output for variations already live in production.
  const highlightedHeading = useHighlightedText(firstName ? configuredHeading : HEADING_DEFAULTS.heading)
  const resolvedHeading = maskFirstName(highlightedHeading)

  return (
    <div className="heading-module">
      <Heading text={resolvedHeading} as="h1" />
      <Subheading text={subheading || HEADING_DEFAULTS.subheading} />
    </div>
  )
}
